import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCommits: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCommits"><Path d="M12 6C14.9729 6 17.4388 8.16245 17.915 11H23V13H17.915C17.4388 15.8376 14.9729 18 12 18C9.02712 18 6.56117 15.8376 6.08496 13H1V11H6.08496C6.56117 8.16245 9.02712 6 12 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCommits;
